import ReactDOM from 'react-dom';
import { usePortalContainer } from '../utils/usePortalContainer';
export function Portal({ container, children }) {
    const defaultContainer = usePortalContainer();
    return ReactDOM.createPortal(children, container !== null && container !== void 0 ? container : defaultContainer);
}
